import React from "react";
import { Card, Typography, Popconfirm, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import ElementContent from "./ElementContent";

const { Text } = Typography;

export default function GalleryCard({ tpl, onClick, onDelete, deleting }) {
  const isLandscape = tpl.orientation === "landscape";
  const designW = isLandscape ? 1123 : 794;
  const designH = isLandscape ? 794 : 1123;
  const cardW = 168;
  const cardH = Math.round(cardW * (designH / designW));
  const scale = cardW / designW;
  const elements = tpl.elements;

  return (
    <div style={{ width: cardW }}>
      <Card
        hoverable
        onClick={onClick}
        styles={{ body: { padding: 0 } }}
        style={{ width: cardW, borderRadius: 8, overflow: "hidden" }}
        cover={
          <div style={{ width: cardW, height: cardH, background: "#fff", position: "relative", overflow: "hidden" }}>
            {onDelete && (
              <Popconfirm
                title="Delete this template?"
                okText="Delete"
                okButtonProps={{ danger: true }}
                onConfirm={(e) => {
                  e?.stopPropagation();
                  onDelete(tpl);
                }}
                onCancel={(e) => e?.stopPropagation()}
              >
                <Button
                  onClick={(e) => e.stopPropagation()}
                  danger
                  type="primary"
                  shape="circle"
                  size="small"
                  icon={<DeleteOutlined style={{ fontSize: 11 }} />}
                  loading={deleting}
                  style={{ position: "absolute", top: 6, right: 6, zIndex: 2, width: 24, height: 24, minWidth: 24, padding: 0, boxShadow: "0 1px 4px rgba(0,0,0,0.25)" }}
                />
              </Popconfirm>
            )}
            {elements.length === 0 ? (
              <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#C7CFDA" }}>
                Empty
              </div>
            ) : (
              <div style={{ position: "absolute", top: 0, left: 0, width: designW, height: designH, transform: `scale(${scale})`, transformOrigin: "top left", pointerEvents: "none" }}>
                {elements.map((el, i) => (
                  <div key={el.id || i} style={{ position: "absolute", left: el.x, top: el.y, width: el.w, height: el.h, boxSizing: "border-box" }}>
                    <ElementContent el={el} />
                  </div>
                ))}
              </div>
            )}
          </div>
        }
      >
        <div style={{ padding: "10px 12px", textAlign: "center" }}>
          <Text strong style={{ fontSize: 13, color: "#33404F" }}>
            {tpl.label}
          </Text>
          {tpl.description && <div style={{ fontSize: 11, marginTop: 2, color: "#8A94A3" }}>{tpl.description}</div>}
        </div>
      </Card>
    </div>
  );
}
